export default {
	LIBRARY: '/library/',
	MARKET: 'market/init',
	UPGRADE: 'upgrade',
	CHECKOUT: 'checkout',
	LOCKED_CONTENT: 'locked-content',
	INTERACTIVE_VIDEO_CREATE: 'interactive-video/create',
	INTERACTIVE_VIDEO_SELECT: 'interactive-video/select',
	VIDEO_PICKER_CREATE: 'video/create',
}
